<template>
    <div class="box">
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
            </div>
        </div>
        <div class="box-content">
          <div class="flex justify-end">
            <a class="btn-primary" href="/promotional-slides/new">
              Add New
            </a>
          </div>
            <template v-if="!loading && total_count > 0">
              <div class="promotional-slides-admin-wrapper">
                <template v-for="promotional_slide in promotional_slides">
                  <a class="promotional-slide"
                     :href="promotional_slide.link"
                     target="_blank"
                     :style="slideStyle(promotional_slide)"
                     :class="{
                  '_image-left': promotional_slide.main_image_side === 'left',
                  '_image-right': promotional_slide.main_image_side === 'right',
                  '_image-none': promotional_slide.main_image_side === 'none'
                }">
                    <div class="promotional-slide-image">
                      <img :src="`${$aws_bucket_url}${promotional_slide.main_image_url}`">
                    </div>
                    <div class="promotional-slide-body">
                      <h1 class="promotional-slide-title">{{ promotional_slide.title }}</h1>
                      <div class="promotional-slide-content">
                        {{ promotional_slide.content }}
                      </div>
                    </div>
                  </a>
                  <div class="flex justify-end mt-3 mb-3">
                    <a @click.stop.prevent="deletePromotionalSlide(promotional_slide)" class="btn-danger mr-1">
                      <i class="fal fa-trash"></i> Delete
                    </a>
                    <a :href="'/promotional-slides/edit/'+promotional_slide.id" class="btn-primary">
                      <i class="fal fa-pencil"></i> Edit
                    </a>
                  </div>
                </template>
              </div>
                <template>
                    <div class="pagination-bar wrapper mb-3 mt-3">
                        <div class="row">
                            <div class="col">
                                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                        class="fa fa-caret-left"></i></a>
                                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                            </div>
                            <div class="col align-right">
                                <div class="mt-1 mb-1">
                                    {{ total_count }} results found
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <template v-if="!loading && total_count === 0">
                <strong>
                    No Results Found
                </strong>
            </template>
        </div>
    </div>
</template>

<script>

  export default {
    mounted() {
      if(window.location.hash) {
        this.current_page = window.location.hash.substring(1);
      }
      this.loadPromotionalSlides();
    },
    props: [
    ],
    data() {
      return {
        promotional_slides: [],
        current_page: 1,
        total_count: 0,
        total_pages: 0,
        limit: 20,
        loading: true,
      }
    },
    methods: {
      loadPromotionalSlides: _.debounce(function () {
        axios.post('/promotional-slides/load-promotional-slides', {
          page_number: this.current_page,
          limit: this.limit,
        }).then((response) => {
          this.promotional_slides = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
          this.loading = false;
        });
      }, 250),
      prevPage() {
        this.current_page = this.current_page - 1;
        this.setPageHash();
        this.loadPromotionalSlides();
      },
      nextPage() {
        this.current_page = this.current_page + 1;
        this.setPageHash();
        this.loadPromotionalSlides();
      },
      deletePromotionalSlide(promotional_slide) {
        Swal.fire({
          title: 'Are you sure you want to remove this slide?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post('/promotional-slides/delete/'+promotional_slide.id, {
              promotional_slide_id: promotional_slide.id,
            }).then((response) => {
              this.current_page = 1;
              this.setPageHash();
              this.loadPromotionalSlides();
              Swal.fire({
                title: 'Slide Deleted',
                icon: 'success',
              });
            });
          }
        });
      },
      setPageHash() {
        window.location = `#${this.current_page}`;
      },
      backgroundImage(promotional_slide) {
        return { backgroundImage: `url(${promotional_slide.background_image_url})` };
      },
      slideStyle(promotional_slide) {
        return {
          backgroundImage: `url(${this.$aws_bucket_url}${promotional_slide.background_image_url})`,
          color: promotional_slide.text_colour,
          backgroundSize: 'cover',
        };
      },
    },
  };
</script>
